import styled from 'styled-components';
import React from 'react';
import { Input } from 'semantic-ui-react';
import {withFormik} from 'formik';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import normalizeErrors from '../normalizeErrors';

const SendMessageWrapper =styled.div`
    grid-column:3;
    grid-row:3;
    margin:20px;
`;

const SendMessage = ({
    channelName,
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  }) => (
    <SendMessageWrapper>
      <Input
        onKeyDown={(e) => {
          if (e.keyCode === 13 && !isSubmitting) {
            handleSubmit(e);
          }
        }}
        onChange={handleChange}
        onBlur={handleBlur}
        name="message"
        value={values.message}
        fluid
        placeholder={`Message #${channelName}`}
      />
    </SendMessageWrapper>
  );
const createMessageMutation=gql`
        mutation($channelId:Int!,$text:String!){
            createMessage(channelId:$channelId,text:$text)
        }
`;
export default compose(
    graphql(createMessageMutation),
    withFormik({
        handleSubmit: async (values, { props: { channelId, mutate }, setSubmitting, resetForm }) => {
        if(!values.message || !values.message.trim()){
            setSubmitting(false);
            return;
        }
        await mutate({
          variables: { channelId,text: values.message},
        });
        resetForm({
            values:{
                message: "", 
            }
        });
      },
    }),
)(SendMessage);